import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";

@Component({
  selector: "app-maintenance-series-details",
  templateUrl: "./maintenance-series-details.component.html",
  styleUrls: ["./maintenance-series-details.component.css"],
})
export class MaintenanceSeriesDetailsComponent implements OnInit {
  hours: any;
  minutes: any;
  estHours: any;
  estMintues: any;
  tphours: any = "00";
  tpminutes: any = "00";
  tptype: any = "AM";
  tshours: any = "00";
  tsminutes: any = "00";
  tstype: any = "AM";

  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  rjRepeatType: any = "1";
  dayfrequency: any = "";
  weekfrequency: any = "";
  monthfrequency: any = "";
  yearfrequency: any = "";
  monthofyear: any = "1";
  rangestart: any = "";
  rangeend: any = "";
  rangeEndAfterValue: any = "1";
  starttime: any = "";
  endtime: any = "";
  timeErrorMsg: any = "";

  isrjRepeatTypeEmpty: boolean = false;
  isDayOneSelected: boolean = true;
  isDayTwoSelected: boolean = false;
  isdayfrequencyEmpty: boolean = false;
  isWeekOneSelected: boolean = true;
  isWeekTwoSelected: boolean = false;
  isweekfrequencyEmpty: boolean = false;
  isWeekTwoMonSelected: boolean = true;
  isWeekTwoTueSelected: boolean = false;
  isWeekTwoWedSelected: boolean = false;
  isWeekTwoThuSelected: boolean = false;
  isWeekTwoFriSelected: boolean = false;
  isWeekTwoSatSelected: boolean = false;
  isWeekTwoSunSelected: boolean = false;
  isMonthOneSelected: boolean = true;
  isMonthTwoSelected: boolean = false;
  isMonthThreeSelected: boolean = false;
  ismonthfrequencyEmpty: boolean = false;
  isMonthThreeOneSelected: boolean = true;
  isMonthThreeSecSelected: boolean = true;
  isMonthThreeThrSelected: boolean = true;
  isMonthThreefourSelected: boolean = true;
  isMonthThreelastSelected: boolean = true;
  isyearfrequencyEmpty: boolean = false;
  isRangeStartShown: boolean = false;
  isRangeEndShown: boolean = false;
  isRepeatMonthSelected: boolean = false;
  isRangeEndOn: boolean = true;
  isRangeEndAfter: boolean = false;
  isParticularDay: boolean = true;
  isSpecifictime: boolean = false;
  israngeEndAfterValueEmpty: boolean = false;
  isDateInvalid: boolean = false;
  israngeDateError: boolean = false;
  isspecifictime: boolean = true;
  iscertainduration: boolean = false;
  isReviewTimeShownTs: boolean = false;
  isSpecificTimeEmpty: boolean = false;
  isActivityStartTimeEmpty: boolean = false;

  isTimeError: boolean = false;
  isTimeEmpty: boolean = false;
  disableIncreaseHours: boolean = false;
  disableDecreaseHours: boolean = false;
  disableIncreaseMinutes: boolean = false;
  disableDecreaseMinutes: boolean = false;
  isSmartMatchChecked: boolean = false;
  isTimepickerInvalid: boolean = false;
  isEstimatedDurationInvalid: boolean = false;
  isMachineIdInvalid: boolean = false;
  isLoadingIcon: boolean = false;
  isExpand: boolean = false;
  isReviewDateShown: boolean = false;
  isReviewTimeShown: boolean = false;
  disableIncreaseHrs: boolean = false;
  disableDecreaseHrs: boolean = false;
  disableIncreaseMins: boolean = false;
  disableDecreaseMins: boolean = false;
  disableIncreaseHrsts: boolean = false;
  disableDecreaseHrsts: boolean = false;
  disableIncreaseMinsts: boolean = false;
  disableDecreaseMinsts: boolean = false;
  isDurationEmpty: boolean = false;

  @Output() gobacktoSeriesStep2 = new EventEmitter<any>();
  @Output() mSeriesStep3Data = new EventEmitter<any>();

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    var dt = new Date();
    var h = dt.getHours(),
      m = dt.getMinutes();
    var _time = h > 12 ? "PM" : "AM";
    this.hours = h >= 10 ? h : "0" + h;
    this.minutes = m >= 10 ? m : "0" + m;
    this.rangestart = dt;
    this.rangeend = dt;
    localStorage.setItem(
      "singleDate",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    localStorage.setItem(
      "startRange",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    localStorage.setItem(
      "endRange",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    this.estHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estMintues = Array(60)
      .fill(0)
      .map((x, i) => i);
  }

  rjRepeatTypeEvent(e: any) {
    this.isDayOneSelected = true;
    this.isDayTwoSelected = false;
    this.isWeekOneSelected = true;
    this.isWeekTwoSelected = false;
    this.isMonthOneSelected = true;
    this.isMonthTwoSelected = false;
    this.isMonthOneSelected = true;
    this.isMonthTwoSelected = false;
    this.isMonthThreeSelected = false;
    (this.isWeekTwoMonSelected = true),
      (this.isWeekTwoTueSelected = false),
      (this.isWeekTwoWedSelected = false),
      (this.isWeekTwoThuSelected = false),
      (this.isWeekTwoFriSelected = false),
      (this.isWeekTwoSatSelected = false),
      (this.isWeekTwoSunSelected = false);
    (this.isMonthThreeOneSelected = true),
      (this.isMonthThreeSecSelected = false),
      (this.isMonthThreeThrSelected = false),
      (this.isMonthThreefourSelected = false),
      (this.isMonthThreelastSelected = false);

    this.monthofyear = "1";
    this.dayfrequency = "";
    this.weekfrequency = "";
    this.monthfrequency = "";
    this.yearfrequency = "";
    this.isdayfrequencyEmpty = false;
    this.isweekfrequencyEmpty = false;
    this.ismonthfrequencyEmpty = false;
    this.isyearfrequencyEmpty = false;

    e.target.value === 1
      ? ((this.isDayOneSelected = true), (this.isDayTwoSelected = false))
      : e.target.value === 2
      ? ((this.isWeekOneSelected = true), (this.isWeekTwoSelected = false))
      : e.target.value === 3
      ? ((this.isMonthOneSelected = true),
        ((this.isMonthTwoSelected = false),
        (this.isMonthThreeSelected = false)))
      : "";
  }

  allowonlynumber(e: any) {
    this.isdayfrequencyEmpty = false;
    this.isweekfrequencyEmpty = false;
    this.ismonthfrequencyEmpty = false;
    this.isyearfrequencyEmpty = false;

    e.target.value = e.target.value.replace(/[^0-9]/g, "");
    this.dayfrequency = e.target.value;
    this.weekfrequency = e.target.value;
    this.monthfrequency = e.target.value;
    this.yearfrequency = e.target.value;
  }

  dayOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isDayOneSelected = true), (this.isDayTwoSelected = false))
      : (this.isDayOneSelected = false);
  }

  dayTwoEvent(e: any) {
    this.dayfrequency = "";
    e.target.checked === true
      ? ((this.isDayTwoSelected = true), (this.isDayOneSelected = false))
      : (this.isDayTwoSelected = false);
  }

  weekOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekOneSelected = true), (this.isWeekTwoSelected = false))
      : (this.isWeekOneSelected = false);
  }

  weekTwoEvent(e: any) {
    this.weekfrequency = "";
    this.isweekfrequencyEmpty = false;
    e.target.checked === true
      ? ((this.isWeekTwoSelected = true), (this.isWeekOneSelected = false))
      : (this.isWeekTwoSelected = false);
  }

  weekTwoMonEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoMonSelected = true),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoMonSelected = false);
  }

  weekTwoTueEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoTueSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoTueSelected = false);
  }

  weekTwoWedEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoWedSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoWedSelected = false);
  }

  weekTwoThuEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoThuSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoThuSelected = false);
  }

  weekTwoFriEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoFriSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoFriSelected = false);
  }

  weekTwoSatEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoSatSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoSatSelected = false);
  }

  weekTwoTSunEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoSunSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false))
      : (this.isWeekTwoSunSelected = false);
  }

  monthOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthOneSelected = true),
        ((this.isMonthTwoSelected = false),
        (this.isMonthThreeSelected = false)))
      : (this.isMonthOneSelected = false);
  }

  monthTwoEvent(e: any) {
    this.isRangeStartShown = false;
    this.isRangeEndShown = false;
    this.monthfrequency = "";
    this.ismonthfrequencyEmpty = false;
    this.yearfrequency = "";
    this.isyearfrequencyEmpty = false;

    e.target.checked === true
      ? ((this.isMonthTwoSelected = true),
        (this.isRepeatMonthSelected = true),
        ((this.isMonthOneSelected = false),
        (this.isMonthThreeSelected = false)))
      : ((this.isMonthTwoSelected = false),
        (this.isRepeatMonthSelected = false));
  }

  monthThreeEvent(e: any) {
    this.monthfrequency = "";
    this.ismonthfrequencyEmpty = false;
    this.yearfrequency = "";
    this.isyearfrequencyEmpty = false;

    e.target.checked === true
      ? ((this.isMonthThreeSelected = true),
        ((this.isMonthOneSelected = false), (this.isMonthTwoSelected = false)))
      : (this.isMonthThreeSelected = false);
  }

  monthThreeOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = true),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreeSecEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = true),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreethrEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = true),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreefourEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = true),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreelastEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = true))
      : "";
  }

  rangeStartDate() {
    this.isRangeEndShown = false;
    this.isRangeStartShown = !this.isRangeStartShown;
  }

  rangeEndDate() {
    this.isRangeStartShown = false;
    this.isRangeEndShown = !this.isRangeEndShown;
  }

  rangeEndOnEvent(e: any) {
    e.target.checked === true
      ? ((this.isRangeEndOn = true), (this.isRangeEndAfter = false))
      : (this.isRangeEndOn = false);
  }

  rangeEndAfterEvent(e: any) {
    e.target.checked === true
      ? ((this.isRangeEndAfter = true), (this.isRangeEndOn = false))
      : (this.isRangeEndAfter = false);
  }

  applyRangeStartDate() {
    var d = localStorage.getItem("startRange");
    this.rangestart = d.split("/").reverse().join("-");
    localStorage.setItem("startRange", d);
    this.isRangeStartShown = false;
  }

  applyRangeEndDate() {
    var d = localStorage.getItem("endRange");
    var ed = d.split("/").reverse().join("-");

    if (new Date(ed) > new Date(this.rangestart)) {
      this.rangeend = ed;
      localStorage.setItem("endRange", d);
      this.isRangeEndShown = false;
      this.israngeDateError = false;
    } else {
      this.rangeend = ed;
      localStorage.setItem("endRange", d);
      this.isRangeEndShown = false;
      this.israngeDateError = true;
    }
  }

  closeRangeStartDate() {
    this.isRangeStartShown = false;
  }

  closeRangeEndDate() {
    this.isRangeEndShown = false;
  }

  particularDay(e: any) {
    e.target.checked === true
      ? ((this.isParticularDay = true), (this.isSpecifictime = false))
      : (this.isParticularDay = false);
  }

  specifictime(e: any) {
    e.target.checked === true
      ? ((this.isSpecifictime = true),
        (this.tphours = "00"),
        (this.tpminutes = "00"),
        (this.isParticularDay = false))
      : (this.isSpecifictime = false);
  }

  increaseHrs() {
    var hrs = parseInt(this.tphours) + 1;
    this.disableDecreaseHrs = false;
    this.isActivityStartTimeEmpty = false;
    if (hrs >= 12) {
      this.tphours = 12;
      this.disableIncreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrs = false;
    }
  }

  decreaseHrs() {
    var hrs = parseInt(this.tphours) - 1;
    this.disableIncreaseHrs = false;
    this.isActivityStartTimeEmpty = false;
    if (hrs <= 0) {
      this.tphours = "00";
      this.disableDecreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrs = false;
    }
  }

  increaseMins() {
    var mins = parseInt(this.tpminutes) + 1;
    this.disableDecreaseMins = false;
    this.isActivityStartTimeEmpty = false;
    if (mins > 59) {
      this.disableIncreaseMins = true;
    } else {
      this.disableIncreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMins() {
    var mins = parseInt(this.tpminutes);
    this.disableIncreaseMins = false;
    this.isActivityStartTimeEmpty = false;
    if (mins === 0) {
      this.disableDecreaseMins = true;
      this.tpminutes = "00";
    } else {
      mins = parseInt(this.tpminutes) - 1;
      this.disableDecreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  increaseHours() {
    var hrs = parseInt(this.hours) + 1;
    this.isDurationEmpty = false;

    this.disableDecreaseHours = false;
    if (hrs === 24) {
      this.disableIncreaseHours = true;
      this.disableIncreaseMinutes = true;
      this.disableDecreaseMinutes = true;
      this.hours = "24";
      this.minutes = "00";
    } else {
      this.disableIncreaseHours = false;
      this.hours = hrs >= 10 ? hrs : "0" + hrs;
    }
  }

  decreaseHours() {
    var hrs = parseInt(this.hours) - 1;
    this.isDurationEmpty = false;
    this.disableIncreaseHours = false;
    this.disableIncreaseMinutes = false;
    if (hrs === 0) {
      this.disableDecreaseHours = true;
      this.hours = "00";
    } else {
      this.disableDecreaseHours = false;
      this.hours = hrs >= 10 ? hrs : "0" + hrs;
    }
  }

  increaseMinutes() {
    var mins = parseInt(this.minutes) + 1;
    this.isDurationEmpty = false;
    this.disableDecreaseMinutes = false;
    if (mins > 59) {
      this.disableIncreaseMinutes = true;
    } else {
      this.disableIncreaseMinutes = false;
      this.minutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMinutes() {
    var mins = parseInt(this.minutes);
    this.isDurationEmpty = false;
    this.disableIncreaseMinutes = false;
    if (mins === 0) {
      this.disableDecreaseMinutes = true;
      this.minutes = "00";
    } else {
      mins = parseInt(this.minutes) - 1;
      this.disableDecreaseMinutes = false;
      this.minutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  changetimeformat() {
    var f = this.tptype;
    f === "AM" ? (this.tptype = "PM") : (this.tptype = "AM");
    this.isActivityStartTimeEmpty = false;
  }

  closeTime() {
    this.isReviewTimeShown = false;
  }

  closeTimeTs() {
    this.isReviewTimeShownTs = false;
  }

  reviewTimeEventTs() {
    this.isReviewTimeShownTs = !this.isReviewTimeShownTs;
  }

  tsspecifictime(e: any) {
    this.tshours = "00";
    this.tsminutes = "00";
    this.tstype = "AM";

    this.isspecifictime = true;
    this.iscertainduration = false;
    this.isDurationEmpty = false;
  }

  tscertainduration(e: any) {
    this.tshours = "00";
    this.tsminutes = "00";
    this.tstype = "AM";

    this.isspecifictime = false;
    this.iscertainduration = true;
    this.isTimeError = false;
    this.isTimeEmpty = false;
  }

  increaseHrsts() {
    var hrs = parseInt(this.tshours) + 1;
    this.disableDecreaseHrsts = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (hrs >= 12) {
      this.tshours = 12;
      this.disableIncreaseHrsts = true;
    } else {
      this.tshours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrsts = false;
    }
  }

  decreaseHrsts() {
    var hrs = parseInt(this.tshours) - 1;
    this.disableIncreaseHrsts = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (hrs <= 0) {
      this.tshours = "00";
      this.disableDecreaseHrsts = true;
    } else {
      this.tshours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrsts = false;
    }
  }

  increaseMinsts() {
    var mins = parseInt(this.tsminutes) + 1;
    this.disableDecreaseMinsts = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (mins > 59) {
      this.disableIncreaseMinsts = true;
    } else {
      this.disableIncreaseMinsts = false;
      this.tsminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMinsts() {
    var mins = parseInt(this.tsminutes);
    this.disableIncreaseMinsts = false;
    this.isTimeEmpty = false;
    this.isTimeError = false;
    if (mins === 0) {
      this.disableDecreaseMinsts = true;
      this.tsminutes = "00";
    } else {
      mins = parseInt(this.tsminutes) - 1;
      this.disableDecreaseMinsts = false;
      this.tsminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  mSeriesStep2Event() {
    console.log("hrs of estimated dur----", this.hours);
    
    this.isLoadingIcon = true;
    var repeatOption: any;
    var rjRepeatType1 = false;

    // Day
    if (this.rjRepeatType === "1" && this.isDayOneSelected) {
      if (this.dayfrequency === "") {
        this.isdayfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.dayfrequency),
          onWeekday: 0,
        };
      }
    } else if (this.rjRepeatType === "1" && this.isDayTwoSelected) {
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        onWeekday: 1,
      };
    }

    // Week
    if (this.rjRepeatType === "2" && this.isWeekOneSelected) {
      if (this.weekfrequency === "") {
        this.isweekfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.weekfrequency),
          daysofweek: 0,
          isfrequency: true,
        };
      }
    } else if (this.rjRepeatType === "2" && this.isWeekTwoSelected) {
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        daysofweek: this.isWeekTwoMonSelected
          ? 2
          : this.isWeekTwoTueSelected
          ? 3
          : this.isWeekTwoWedSelected
          ? 4
          : this.isWeekTwoThuSelected
          ? 5
          : this.isWeekTwoFriSelected
          ? 6
          : this.isWeekTwoSatSelected
          ? 0
          : this.isWeekTwoSunSelected
          ? 1
          : "",
        isfrequency: false,
      };
    }

    // Month
    if (this.rjRepeatType === "3" && this.isMonthOneSelected) {
      if (this.monthfrequency === "") {
        this.ismonthfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.monthfrequency),
          dateofmonth: 0,
          daysofweek: {
            weekindex: 0,
            dayindex: 0,
          },
          isfrequency: true,
          isdateofmonth: false,
        };
      }
    } else if (this.rjRepeatType === "3" && this.isMonthTwoSelected) {
      var d = localStorage.getItem("singleDate");
      var date = new Date(d).getDate();
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofmonth: parseInt(d),
        daysofweek: {
          weekindex: 0,
          dayindex: 0,
        },
        isfrequency: false,
        isdateofmonth: true,
      };
    } else if (this.rjRepeatType === "3" && this.isMonthThreeSelected) {
      var d = localStorage.getItem("singleDate");
      var date = new Date(d).getDate();
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofmonth: parseInt(d),
        daysofweek: {
          weekindex: this.isMonthThreeOneSelected
            ? 1
            : this.isMonthThreeSecSelected
            ? 2
            : this.isMonthThreeThrSelected
            ? 3
            : this.isMonthThreefourSelected
            ? 4
            : this.isMonthThreelastSelected
            ? 0
            : "",
          dayindex: this.isWeekTwoMonSelected
            ? 2
            : this.isWeekTwoTueSelected
            ? 3
            : this.isWeekTwoWedSelected
            ? 4
            : this.isWeekTwoThuSelected
            ? 5
            : this.isWeekTwoFriSelected
            ? 6
            : this.isWeekTwoSatSelected
            ? 0
            : this.isWeekTwoSunSelected
            ? 1
            : "",
        },
        isfrequency: false,
        isdateofmonth: false,
      };
    }

    // Year
    if (this.rjRepeatType === "4" && this.isMonthOneSelected) {
      if (this.yearfrequency === "") {
        this.isyearfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.yearfrequency),
          dateofyear: {
            date: 0,
            month: 0,
          },
          daysofweekofmonth: {
            monthindex: 0,
            weekindex: 0,
            dayindex: 0,
          },
          isfrequency: true,
          isdateofyear: false,
        };
      }
    } else if (this.rjRepeatType === "4" && this.isMonthTwoSelected) {
      var d = localStorage.getItem("singleDate");
      var getDate = d.split("/").reverse().join("-");

      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofyear: {
          date: new Date(getDate).getDate(),
          month: new Date(getDate).getMonth() + 1,
        },
        daysofweekofmonth: {
          monthindex: parseInt(this.monthofyear),
          weekindex: this.isMonthThreeOneSelected
            ? 1
            : this.isMonthThreeSecSelected
            ? 2
            : this.isMonthThreeThrSelected
            ? 3
            : this.isMonthThreefourSelected
            ? 4
            : this.isMonthThreelastSelected
            ? 0
            : "",
          dayindex: this.isWeekTwoMonSelected
            ? 2
            : this.isWeekTwoTueSelected
            ? 3
            : this.isWeekTwoWedSelected
            ? 4
            : this.isWeekTwoThuSelected
            ? 5
            : this.isWeekTwoFriSelected
            ? 6
            : this.isWeekTwoSatSelected
            ? 0
            : this.isWeekTwoSunSelected
            ? 1
            : "",
        },
        isfrequency: false,
        isdateofyear: true,
      };
    } else if (this.rjRepeatType === "4" && this.isMonthThreeSelected) {
      var d = localStorage.getItem("singleDate");
      var d = localStorage.getItem("singleDate");
      var getDate = d.split("/").reverse().join("-");

      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofyear: {
          date: new Date(getDate).getDate(),
          month: new Date(getDate).getMonth() + 1,
        },
        daysofweekofmonth: {
          monthindex: parseInt(this.monthofyear),
          weekindex: this.isMonthThreeOneSelected
            ? 1
            : this.isMonthThreeSecSelected
            ? 2
            : this.isMonthThreeThrSelected
            ? 3
            : this.isMonthThreefourSelected
            ? 4
            : this.isMonthThreelastSelected
            ? 0
            : "",
          dayindex: this.isWeekTwoMonSelected
            ? 2
            : this.isWeekTwoTueSelected
            ? 3
            : this.isWeekTwoWedSelected
            ? 4
            : this.isWeekTwoThuSelected
            ? 5
            : this.isWeekTwoFriSelected
            ? 6
            : this.isWeekTwoSatSelected
            ? 0
            : this.isWeekTwoSunSelected
            ? 1
            : "",
        },
        isfrequency: false,
        isdateofyear: false,
      };
    }

    var sr = localStorage.getItem("startRange").split("/").reverse().join("-");
    var er = localStorage.getItem("endRange").split("/").reverse().join("-");

    var range = {
      startdate: sr,
      end: {
        enddate: er,
        occurances: parseInt(this.rangeEndAfterValue),
        isOccurance: this.isRangeEndAfter,
      },
    };

    var hr = this.hours;

    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;
    var ehour =
      this.tstype === "AM" ? this.tshours : parseInt(this.tshours) + 12;

    console.log("ehour-----", ehour)
    this.starttime = shour + ":" + this.tpminutes;
    this.endtime = ehour + ":" + this.tsminutes;

    var start = hr + ':' + this.minutes;


  

    if(this.iscertainduration){
      var minusStartTime: any = shour + '.' + this.tpminutes;
      var minusEndTime: any = hr + "." + this.minutes;
      console.log("t ----", minusEndTime);

      var t: any = (minusEndTime - 0).toString();
       console.log("t ----", minusEndTime ,'--------' , minusStartTime);


    } else {
      var minusStartTime: any = shour + "." + this.tpminutes;
      var minusEndTime: any = ehour + "." + this.tsminutes;
      console.log("t ----", minusEndTime);

      var t: any = (minusEndTime - minusStartTime).toString();
      console.log("t ----", t);

    }

    console.log("start of estimation ----", start);
    
    var totalDuration: any = t.split(".");

    console.log("totalDuration --->", totalDuration);


    var n =
      totalDuration.length > 1 ? parseInt(totalDuration[1].slice(0, 2)) : 0;

    console.log("n", n);
   

    if (n > 59) {
      let a = n - 60;
      let b = n - (a + parseInt(this.tpminutes));
      totalDuration[1] = b >= 10 ? b.toString() : "0" + b;
    } else {
      totalDuration[1] = n >= 10 ? n.toString() : "0" + n;
    }


    console.log(this.starttime + "------" + this.endtime);

    if (this.isspecifictime) {
      if (this.starttime > this.endtime) {
        this.isTimeError = true;
      } else if (this.starttime === this.endtime) {
        this.isTimeError = true;
      } else {
        this.isTimeError = false;
      }
    }

    if (
      this.iscertainduration &&
      parseInt(this.hours) === 0 &&
      parseInt(this.minutes) === 0
    ) {
      this.isDurationEmpty = true;
    } else {
      this.isDurationEmpty = false;
    }

    var startOption = {
      startTime: {
        hours: shour,
        minutes: this.tpminutes.toString(),
      },
    };

    var endOption = {
      endTime: {
        hours: ehour.toString(),
        minutes: this.tsminutes.toString(),
        totalDuration: (totalDuration[0] + ":" + totalDuration[1]).toString(),
      },
      duration: {
        hours: totalDuration[0],
        minutes: totalDuration[1],
      },
      isEndTime: this.isspecifictime ? true : false,
    };

    if (!this.isRangeEndAfter) {
      if (new Date(sr) >= new Date(er)) {
        this.israngeDateError = true;
      } else {
        this.israngeDateError = false;
      }
    } else {
      this.israngeDateError = false;
    }

    this.isReviewTimeShownTs = false;

    if (this.isspecifictime) {
      if (parseInt(this.tshours) === 0 && parseInt(this.tsminutes) === 0) {
        this.isTimeEmpty = true;
      } else {
        this.isTimeEmpty = false;
      }
    }

    if (parseInt(this.tphours) === 0 && parseInt(this.tpminutes) === 0) {
      this.isActivityStartTimeEmpty = true;
    } else {
      this.isActivityStartTimeEmpty = false;
    }

    if (this.isspecifictime) {
      if (
        rjRepeatType1 &&
        !this.isTimeEmpty &&
        !this.israngeDateError &&
        !this.isActivityStartTimeEmpty &&
        !this.isTimeError &&
        !this.israngeDateError
      ) {
        console.log("repeatType", this.rjRepeatType);
        console.log("repeatOption", repeatOption);
        console.log("range", range);
        console.log("startOption", startOption);
        console.log("endOption", endOption);

        this.mSeriesStep3Data.emit({
          repeatType: this.rjRepeatType,
          repeatOption: repeatOption,
          range: range,
          startOption: startOption,
          endOption: endOption,
        });
      }
    } else {
      if (
        rjRepeatType1 &&
        !this.isTimeEmpty &&
        !this.israngeDateError &&
        !this.isActivityStartTimeEmpty &&
        !this.isDurationEmpty &&
        !this.israngeDateError
      ) {
        console.log("repeatType", this.rjRepeatType);
        console.log("repeatOption", repeatOption);
        console.log("range", range);
        console.log("startOption", startOption);
        console.log("endOption", endOption);

        this.mSeriesStep3Data.emit({
          repeatType: this.rjRepeatType,
          repeatOption: repeatOption,
          range: range,
          startOption: startOption,
          endOption: endOption,
        });
      }
    }
  }

  changetimeformatts() {
    var f = this.tstype;
    f === "AM" ? (this.tstype = "PM") : (this.tstype = "AM");
  }

  back() {
    this.gobacktoSeriesStep2.emit();
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }
}
